import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'
import yaml from 'yaml'

import { ContentBodyType, ITransformedLocales, RootDataType } from '../model/types'
import { formSchema } from '../model/model'
import { cleanPreview } from '@/shared/lib'
import { spec_data } from '@/widgets/post/lib/utils'
import { saveFileToFolder } from '@/entities/opfs/utils'

export const NEW_POST_DIR = 'new-post'
export const NEW_COMMENT_DIR = 'content'

export const createPostBody = async ({
  commentData,
  address,
  form,
  pathToFolder,
  fundraiser
}: {
  commentData: RootDataType | null
  address: `0x${string}`
  domain: string
  form: UseFormReturn<z.infer<typeof formSchema>>
  pathToFolder: string
  fundraiser: string | number
}
) => {
  const { locales, thumbnail, isNsfw } = form.getValues()
  const formData = new FormData()

  // Transform locales data
  const transformedLocales = {}
  
  for (const [key, locale] of Object.entries(locales)) {
    if (!locale.data) continue
    if (!locale.title || !locale.data ) continue
    
    if (commentData) {
      transformedLocales[key] = {
        text_preview: cleanPreview(locale.data),
        data_path: locale.data ? `${key}/data.md` : '',
      }
    } else {
      transformedLocales[key] = {
        tags: locale.tags.map(tag => tag.value),
        chapters: locale.chapters.slice(1).map(({ title }, idx) => ({
          title,
          data_path: `${key}/chapter_${idx + 1}.md`
        })),
        text_preview: cleanPreview(locale.data),
        data_path: locale.data ? `${key}/data.md` : '',
        title: locale.title,
        categories: locale.categories.map(el => el.value)
      } satisfies ITransformedLocales
    }
  }

  // Prepare files for upload
  for (const [key, locale] of Object.entries(locales)) {
    if (!locale.title || !locale.data ) continue
    // Add chapter files
    if(locale.chapters.length) {
      locale.chapters.slice(1).forEach(({ data }, idx) => {
      const chapter = new File([data!], `${key}/chapter_${idx + 1}.md`)
      saveFileToFolder(`${pathToFolder}/${key}`, chapter, `chapter_${idx + 1}.md`)
      // formData.append('file', chapter, `/${pathToFolder}/${key}/chapter_${idx + 1}.md`)
    })

    }
    
    // Add main content file
        const data = new File([locale.data!], `${key}/data.md`)
    saveFileToFolder(`${pathToFolder}/${key}`, data, `data.md`)
    // formData.append('file', data, `/${pathToFolder}/${key}/data.md`)
  }

  // Prepare main body content
  const mainBody: ContentBodyType = {
    ...spec_data,
    author: address,
    thumbnail,
    nsfw: !!isNsfw,
    fundraiser: fundraiser ? Number(fundraiser) : 0,
    locales: transformedLocales,
    ...(commentData && { ...commentData })
  }

  // Create and add YAML file
  const yml = yaml.stringify(mainBody)
  const blob = new Blob([yml], { type: 'text/markdown' })
  const info = new File([blob], `/${pathToFolder}/info.yaml`)
  await saveFileToFolder(pathToFolder, info, 'info.yaml')

  // formData.append('file', info, `/${pathToFolder}/info.yaml`)

  // Add domain info
  // formData.append('domain', domain)

  return formData
}